export default "__VITE_ASSET__BXwzeAka__"